const BASE_URL  = process.env.GATSBY_API_BASE_URL ?? '';
const API_KEY   = process.env.GATSBY_API_KEY ?? '';
const API_TOKEN = process.env.GATSBY_API_TOKEN ?? '';
const ORIGIN    = process.env.GATSBY_ORIGIN_URL ?? 'https://qa.comfama.com';

const getFamilyUserId = (): string => localStorage.getItem('FamilyUserID') ?? '';

const getHeaders = (includeContentType = false): Record<string, string> => ({
    'accept': 'application/json, text/plain, */*',
    'accept-language': 'es-ES,es;q=0.9',
    'apikey': API_KEY,
    'origin': ORIGIN,
    'sec-fetch-dest': 'empty',
    'sec-fetch-mode': 'cors',
    'sec-fetch-site': 'same-site',
    'Authorization': `Bearer ${API_TOKEN}`,
    ...(includeContentType && { 'content-type': 'application/json' }),
});

// ─── GET ─────────────────────────────────────────────────────────────────────

export const getUserResponses = (userId = getFamilyUserId()): Promise<Response> =>
    fetch(`${BASE_URL}/getResponsesByUser/${userId}`, {
        method: 'GET',
        headers: getHeaders(),
    });

export const getPaymentHistory = (userId = getFamilyUserId()): Promise<Response> =>
    fetch(`${BASE_URL}/payments/history?userId=${userId}`, {
        method: 'GET',
        headers: getHeaders(),
    });

export const getSavingInstallments = (
    userId = getFamilyUserId(),
    page: number,
    pageSize: number,
): Promise<Response> =>
    fetch(`${BASE_URL}/saving-plans/${userId}/installments/${page}/${pageSize}`, {
        method: 'GET',
        headers: getHeaders(),
    });

export const getMilestones = (userId = getFamilyUserId()): Promise<Response> =>
    fetch(`${BASE_URL}/families/${userId}/milestones`, {
        method: 'GET',
        headers: getHeaders(),
    });

export const getUserNotifications = (
    userId = getFamilyUserId(),
    page = 0,
    size = 10,
): Promise<Response> =>
    fetch(`${BASE_URL}/user-notifications?userId=${userId}&page=${page}&size=${size}`, {
        method: 'GET',
        headers: getHeaders(),
    });

export const markNotificationAsRead = (id: number): Promise<Response> =>
    fetch(`${BASE_URL}/user-notifications/${id}/read`, {
        method: 'PATCH',
        headers: getHeaders(),
    });

// ─── POST ────────────────────────────────────────────────────────────────────

export const postPayment = (body: {
    userId: number;
    amount: number;
    paymentDate: string;
}): Promise<Response> =>
    fetch(`${BASE_URL}/payments`, {
        method: 'POST',
        headers: getHeaders(true),
        body: JSON.stringify(body),
    });

export const saveUserResponses = (changes: object[]): Promise<Response> =>
    fetch(`${BASE_URL}/saveResponseByUserHabitat`, {
        method: 'POST',
        headers: getHeaders(true),
        body: JSON.stringify(changes),
    });

export const getTrainingVideos = (userId: number | string): Promise<Response> =>
    fetch(`${BASE_URL}/habitat/training-videos?userId=${userId}`, {
        method: 'GET',
        headers: getHeaders(),
    });

export const getCurrentStateByUser = (userDocument: string): Promise<Response> =>
    fetch(`${BASE_URL}/getCurrentStateByUser`, {
        method: 'POST',
        headers: getHeaders(true),
        body: JSON.stringify({ userDocument, documentTypeId: 1 }),
    });

export const getSavingPlan = (userId: string | number): Promise<Response> =>
    fetch(`${BASE_URL}/getSavingPlan/${userId}`, {
        method: 'GET',
        headers: getHeaders(),
    });
